import React from "react";
import PropTypes from "prop-types";
import {
  XAxis,
  YAxis,
  BarChart,
  Bar,
  Cell,
  ResponsiveContainer,
} from "recharts";
import { useTranslation } from "react-i18next";
import useAvailableColors from "@client.hooks/useAvailableColors";
import CustomXAxisTick, { XAXIS_PADDING } from "./CustomXAxisTick";

const TopMeetingParticipantsChart = ({
  data,
  handleBarMouseMove,
  handleBarMouseEnter,
  handleBarMouseLeave,
  showDetailsModal,
}) => {
  const { t } = useTranslation();
  const [getSubsequentColor] = useAvailableColors();

  const formatYAxis = (value) =>
    t("components.TopMeetingParticipants.yAxisFormat", { value });
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        margin={{
          top: 20,
          right: 0,
          left: 0,
          bottom: 10,
        }}
        barSize={20}
      >
        <XAxis
          dataKey="name"
          scale="point"
          className="top-meeting-participants-xaxis"
          padding={XAXIS_PADDING}
          axisLine={false}
          tick={<CustomXAxisTick barQty={data.length} />}
          interval={0}
        />
        <YAxis axisLine={false} tickFormatter={formatYAxis} />
        <Bar
          dataKey="value"
          radius={[9, 9, 9, 9]}
          onMouseMove={handleBarMouseMove}
          onMouseEnter={handleBarMouseEnter}
          onMouseLeave={handleBarMouseLeave}
          onClick={showDetailsModal}
          className="clickable-item"
        >
          {data.map((_, index) => (
            <Cell key={`tmp-${index}`} fill={getSubsequentColor(index)} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

TopMeetingParticipantsChart.propTypes = {
  data: PropTypes.array.isRequired,
  handleBarMouseEnter: PropTypes.func.isRequired,
  handleBarMouseMove: PropTypes.func.isRequired,
  handleBarMouseLeave: PropTypes.func.isRequired,
  showDetailsModal: PropTypes.func.isRequired,
};

export default TopMeetingParticipantsChart;
